import { apiFetch } from './client'
import type { MarketAnalysis, MarketReportResponse, MarketState } from '../types/market'

export function fetchMarketState(symbol: string): Promise<MarketState> {
  return apiFetch<MarketState>(`/api/market/${encodeURIComponent(symbol)}`)
}

export function fetchMarketAnalysis(
  symbol: string,
  timeframe: string,
  provider: string
): Promise<MarketAnalysis> {
  return apiFetch<MarketAnalysis>(
    `/api/market/analyze?symbol=${encodeURIComponent(symbol)}&timeframe=${encodeURIComponent(timeframe)}&provider=${encodeURIComponent(provider)}`
  )
}

export function generateMarketReport(asset: string): Promise<MarketReportResponse> {
  return apiFetch<MarketReportResponse>('/api/market/report', {
    method: 'POST',
    body: JSON.stringify({ asset }),
  })
}
